import { CircularProgress, Divider, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import axios from "../../../api/axios";
import { toast } from "react-toastify";

import { useCallback } from "react";
import Errors from "../../../utils/Errors";
import HSCodesDeleteDialog from "./HSCodesDeleteDialog";
import HSCodesEditDialog from "./HSCodesEditDialog";

const HSCodesListItem = ({ hsCode, onRefresh }) => {
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [defaultLoading, setDefaultLoading] = useState(false);
  const [HSCodesDelete, setHSCodesDelete] = useState(false);
  const [HSCodesEdit, setHSCodesEdit] = useState(false);


  const handleDeleteHsCodeListItem = useCallback(() => {
    setDeleteLoading(true);

    axios
      .post(`member-hs-code/delete/${hsCode.id}`)
      .then(() => {
        toast.success("HS Kodu Sistemden Silindi", { autoClose: 500 });
        if (onRefresh) {
          onRefresh();
        }
      })
      .catch((error) => Errors(error))
      .finally(() => {
        setDeleteLoading(false);
        setHSCodesDelete(false);
      });
  }, [hsCode, onRefresh]);

  const handleSetDefault = useCallback(() => {
    if (defaultLoading) return; // Prevent multiple clicks
    
    setDefaultLoading(true);
    
    axios
      .post(`member-hs-code/set-default/${hsCode.id}`)
      .then(() => {
        toast.success("Varsayılan HS Kodu Güncellendi", { autoClose: 500 });
        if (onRefresh) {
          onRefresh();
        }
      })
      .catch((error) => {
        // console.error("Set default error:", error);
        // Errors(error);
        // Don't refresh on error to maintain current state
      })
      .finally(() => {
        setDefaultLoading(false);
      });
  }, [hsCode, onRefresh, defaultLoading]);

  const handleDeleteDialog = () => {
    setHSCodesDelete(true);
  };

  const handleEditDialog = () => {
    setHSCodesEdit(true);
  };

  return (
    <>
      <HSCodesDeleteDialog
        handleDelete={handleDeleteHsCodeListItem}
        HSCodesDelete={HSCodesDelete}
        setHSCodesDelete={setHSCodesDelete}
      />
      <HSCodesEditDialog
        hsCode={hsCode}
        HSCodesEdit={HSCodesEdit}
        setHSCodesEdit={setHSCodesEdit}
        onRefresh={onRefresh}
      />
      <div
        style={{
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: "33px",
          backgroundColor: hsCode.is_default === "1" ? "var(--btnPastelBlue)" : "transparent",
        }}
      >
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: "600", fontSize: "14px", marginBottom: "4px" }}>
            {hsCode.hs_code}
          </div>
          <div style={{ fontSize: "12px", color: "var(--textSecondary)" }}>
            {hsCode.description}
          </div>
          {hsCode.supplier_id && (
            <div style={{ fontSize: "11px", color: "var(--textTertiary)", marginTop: "2px" }}>
              Tedarikçi: {hsCode.supplier_id}
            </div>
          )}
        </div>
        
        <div style={{ display: "flex", gap: "8px" }}>
          {/* <Tooltip title={hsCode.is_default === "1" ? "Varsayılan HS Kodu" : "Varsayılan Yap"}>
            <IconButton
              size="small"
              onClick={handleSetDefault}
              disabled={defaultLoading}
              sx={{
                color: hsCode.is_default === "1" ? "var(--warning)" : "var(--textSecondary)",
                padding: "4px",
                opacity: defaultLoading ? 0.6 : 1,
              }}
            >
              {defaultLoading ? (
                <CircularProgress size={16} />
              ) : hsCode.is_default === "1" ? (
                <StarIcon fontSize="small" />
              ) : (
                <StarBorderIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip> */}
          
          <Tooltip title="Düzenle">
            <IconButton
              size="small"
              onClick={handleEditDialog}
              sx={{
                color: "var(--btnBgBlue)",
                padding: "4px",
                ":hover": { color: "var(--btnBgBlueHover)" },
              }}
            >
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          
          {deleteLoading ? (
            <div
              style={{
                height: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress sx={{ height: "20px !important", width: "20px !important" }} />
            </div>
          ) : (
            <Tooltip title="Sil">
              <IconButton
                size="small"
                onClick={handleDeleteDialog}
                sx={{
                  color: "var(--redBrand)",
                  padding: "4px",
                  ":hover": { color: "var(--notRed)" },
                }}
              >
                <DeleteOutlineOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
      <Divider
        sx={{
          height: "1px",
          width: "100%",
          backgroundColor: "var(--inputBorderColor)",
        }}
      />
    </>
  );
};

export default HSCodesListItem;
